module.exports = __webpack_public_path__ + "static/img/maprinter-qrcode.b52d07f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/maprinter-qrcode.png
// module id = +vfK
// module chunks = 1